// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /contatos_fidelizacao/buscaContatosFidelizacaoPorClienteID
 *
 * Returns a list of loyalty contacts (contatos_fidelizacao) for a given cliente_id.
 * Each row mirrors the contatos_fidelizacao schema (see Row class).
 */
import type { ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidRow } from './ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidResponseDados = ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidRow[];

export type ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidResponse = ApiResponse<ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidResponseDados>;

registerResponseContract('ContatosFidelizacao_BuscacontatosfidelizacaoporclienteidResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      contatofidelizacao_id:                   { type: 'number',  required: true },
      contatofidelizacao_data_cadastro:        { type: 'string',  required: true },
      contatofidelizacao_franquia_id:          { type: 'number',  required: true },
      contatofidelizacao_franquia_nome:        { type: 'string',  required: false },
      contatofidelizacao_cliente_id:           { type: 'number',  required: true },
      contatofidelizacao_owner:                { type: 'string',  required: false },
      contatofidelizacao_owner_id:             { type: 'string',  required: false },
      contatofidelizacao_content:              { type: 'string',  required: true },
      contatofidelizacao_servicoscategoria_id: { type: 'number',  required: false },
      contatofidelizacao_canal:                { type: 'string',  required: false },
    },
  },
})
